// A data de nascimento é guardada à meia-noite UTC. Lida no fuso do Brasil ela cai às 21h do dia
// anterior — por isso tudo aqui usa as partes UTC.

const valida = (v: Date | string | null | undefined) => {
  if (!v) return null;
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** Idade em anos completos (o aniversário de hoje já conta). */
export function idadeEmAnos(birthDate: Date | string | null | undefined): number | null {
  const d = valida(birthDate);
  if (!d) return null;
  const hoje = new Date();
  let anos = hoje.getFullYear() - d.getUTCFullYear();
  const jaFez = hoje.getMonth() > d.getUTCMonth() || (hoje.getMonth() === d.getUTCMonth() && hoje.getDate() >= d.getUTCDate());
  if (!jaFez) anos--;
  return anos >= 0 && anos < 130 ? anos : null;
}

/** dd/mm/aaaa */
export function dataDeNascimento(birthDate: Date | string | null | undefined): string | null {
  const d = valida(birthDate);
  return d ? d.toLocaleDateString("pt-BR", { timeZone: "UTC" }) : null;
}
